module.exports = __webpack_public_path__ + "img/salernitana-logo-icon.14ab47ea.png";